@if (link) { @if (fragment) {
<a [title]="title || label" [attr.aria-label]="title || label" [routerLink]="link" [fragment]="fragment">
  @if (icon) {
  <fa-icon [icon]="icon"></fa-icon>
  } @if (label) {
  <span>{{ label }}</span>
  }
</a>
} @else { @if (!ext) {
<a
  [title]="title || label"
  [attr.aria-label]="title || label"
  [routerLink]="link"
  routerLinkActive="is-active"
  [routerLinkActiveOptions]="{ exact: true }"
>
  @if (icon) {
  <fa-icon [icon]="icon"></fa-icon>
  } @if (label) {
  <span>{{ label }}</span>
  }
</a>
} @if (ext) {
<a [title]="title || label" [attr.aria-label]="title || label" [href]="link" target="_blank">
  @if (icon) {
  <fa-icon [icon]="icon"></fa-icon>
  } @if (label) {
  <span>{{ label }}</span>
  }
</a>
} } } @else { @if (!link) {
<a [title]="title || label" [attr.aria-label]="title || label" href="javascript:;">
  @if (icon) {
  <fa-icon [icon]="icon"></fa-icon>
  } @if (label) {
  <span>{{ label }}</span>
  }
</a>
} } @if (!children?.length) {
<ng-content></ng-content>
} @if (children?.length) {
<div class="nav__item__dropdown-wrapper">
  <div>
    @if (grouped) { @for (item of children; track item) {
    <div class="nav__item__dropdown">
      <span>{{ item.label }}</span>
      @for (subitem of item.children; track subitem) { @if (subitem.ext) {
      <a [href]="subitem.link" target="_blank">{{ subitem.label }}</a>
      } @if (!subitem.ext) {
      <a
        ecpNavLink
        [attr.aria-label]="subitem.label"
        [routerLink]="subitem.link"
        routerLinkActive="is-active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        {{ subitem.label }}
      </a>
      } }
    </div>
    } } @else {
    <div class="nav__item__dropdown">
      @for (item of children; track item) { @if (item.ext) {
      <a [href]="item.link" target="_blank">{{ item.label }}</a>
      } @if (!item.ext) {
      <a
        ecpNavLink
        [title]="item.label"
        [attr.aria-label]="item.label"
        [routerLink]="item.link"
        routerLinkActive="is-active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        {{ item.label }}
      </a>
      } }
    </div>
    }
  </div>
</div>
}
